import { render } from "./ResourceManagementMetadataDialog.vue?vue&type=template&id=2064c9cb&scoped=true&ts=true"
import script from "./ResourceManagementMetadataDialog.vue?vue&type=script&lang=ts"
export * from "./ResourceManagementMetadataDialog.vue?vue&type=script&lang=ts"

import "./ResourceManagementMetadataDialog.vue?vue&type=style&index=0&id=2064c9cb&scoped=true&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2064c9cb"]])

export default __exports__